import * as x from '../helpers/xmlHelpers';
import * as h from '../helpers/helpers';

export class CoolingSystem {
    constructor(doc)
    {
		this.label = null;
		this.coolingSystemType = null;
		this.coolingSystemTypeOtherDescription = null;

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.coolingSystemType = x.getStringElement(doc, "./ns:CoolingSystemType");
		this.coolingSystemTypeOtherDescription = x.getStringElement(doc, "./ns:CoolingSystemTypeOtherDescription");
   }

	GetCoolingType() {
		return h.descriptionOrOther(this.coolingSystemType, this.coolingSystemTypeOtherDescription);
	 }

}

export class HeatingSystem {
    constructor(doc)
    {
		this.label = null;
		this.heatingFuelType = null;
		this.heatingFuelTypeOtherDescription = null;
		this.heatingSystemType = null;
		this.heatingSystemTypeOtherDescription = null;

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.heatingFuelType = x.getStringElement(doc, "./ns:HeatingFuelType");
		this.heatingFuelTypeOtherDescription = x.getStringElement(doc, "./ns:HeatingFuelTypeOtherDescription");
		this.heatingSystemType = x.getStringElement(doc, "./ns:HeatingSystemType");
		this.heatingSystemTypeOtherDescription = x.getStringElement(doc, "./ns:HeatingSystemTypeOtherDescription");
   }

	 GetHeatingType() {
		return h.descriptionOrOther(this.heatingSystemType, this.heatingSystemTypeOtherDescription);
	 }

	 GetFuelType() {
		return h.descriptionOrOther(this.heatingFuelType, this.heatingFuelTypeOtherDescription);
	 }

}

export class MechanicalSystem {
    constructor(doc)
    {
		this.label = null;
		this.mechanicalSystemType = null;
		this.mechanicalSystemTypeOtherDescription = null;

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.mechanicalSystemType = x.getStringElement(doc, "./ns:MechanicalSystemType");
		this.mechanicalSystemTypeOtherDescription = x.getStringElement(doc, "./ns:MechanicalSystemTypeOtherDescription");
   }

	 GetSystemType() {
		return h.descriptionOrOther(this.mechanicalSystemType, this.mechanicalSystemTypeOtherDescription);
	 }

}

export class SystemDetail {
    constructor(doc)
    {
		this.label = null;
		this.coreHeatingSystemBelowGradeIndicator = null;

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.coreHeatingSystemBelowGradeIndicator = x.getBooleanElement(doc, "./ns:CoreHeatingSystemBelowGradeIndicator");
   }
}

export class System {
    constructor(doc)
    {
		this.label = null;
		this.coolingSystems = [];
		this.heatingSystems = [];
		this.mechanicalSystems = [];
		this.systemDetail = null;
		var node;
		var nodes;

		this.label = x.getStringAttribute(doc,"xlink:label");
		nodes = x.selectNodes(doc, "./ns:COOLING_SYSTEMS/ns:COOLING_SYSTEM");
		if (nodes.length > 0)
		{
			nodes.forEach((xn) => {
				this.coolingSystems.push(new CoolingSystem(xn));
			});
		}
		nodes = x.selectNodes(doc, "./ns:HEATING_SYSTEMS/ns:HEATING_SYSTEM");
		if (nodes.length > 0)
		{
			nodes.forEach((xn) => {
				this.heatingSystems.push(new HeatingSystem(xn));
			});
		}
		nodes = x.selectNodes(doc, "./ns:MECHANICAL_SYSTEMS/ns:MECHANICAL_SYSTEM");
		if (nodes.length > 0)
		{
			nodes.forEach((xn) => {
				this.mechanicalSystems.push(new MechanicalSystem(xn));
			});
		}
		node = x.selectSingleNode(doc, "./ns:SYSTEM_DETAIL");
		if (node !== null)
				this.systemDetail = new SystemDetail(node);
  }

	GetHeatingSystems()	{
		var sys = "";
		if (this.heatingSystems.length === 0) return sys;
		for (var hs of this.heatingSystems)	{
				sys = h.addWithNewline(sys, hs.GetHeatingType());
				sys = h.addWithSpacer(sys, hs.GetFuelType());
		}
		return sys;
	}

	GetHeatingSystemsTypes()	{
		var sys = "";
		if (this.heatingSystems.length === 0) return sys;
		for (var hs of this.heatingSystems)	{
				sys = h.addWithNewline(sys, hs.GetHeatingType());
		}
		return sys;
	}

	GetCoolingSystems()	{
		var sys = "";
		if (this.coolingSystems == null) return sys;
		for (var cs of this.coolingSystems)
				sys = h.addWithNewline(sys, cs.GetCoolingType());
		return sys;
	}

	GetCoolingSystemsTypes()	{
		var sys = "";
		if (this.coolingSystems == null) return sys;
		for (var cs of this.coolingSystems)
				sys = h.addWithSpacer(sys, cs.GetCoolingType());
		return sys;
	}

}

